import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { EButton, EInput } from 'src/Components/EInput';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { ISolidsControl, ITest } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import DataTable from '../../../../DataTable';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class SolidsControl extends React.Component {
    public props: any;
    private dataSet: IList;
    private test: ITest = new ITest();
    public TestsStore: any;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;
    private solidsControlItem: ISolidsControl = new ISolidsControl();

    public state = {
        dataSet: this.dataSet,
        deviceNames: [],
        editing: false,
        editingIndex: -1,
        isDirty: false,
        modal: false,
        rowIndex: 0,
        solidsControlItem: this.solidsControlItem,
        test: this.test,
        well: this.well
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;


        this.handleDelete = this.handleDelete.bind(this);

        this.handleCancel = this.handleCancel.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleRadioSelect = this.handleRadioSelect.bind(this);
        this.handleReorder = this.handleReorder.bind(this);

        this.clearDisposers = this.clearDisposers.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();
        this.getDeviceNames();
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            this.setState({
                test: toJS(this.props.stores.TestsStore.test),
                well: toJS(this.props.stores.WellsStore.well)
            }, () => {
                this.formatDataTable();
            });

        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            this.setState({
                test
            }, () => {
                this.formatDataTable();
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            }, () => {
                this.formatDataTable();
            });
        });
    }

    private formatDataTable = () => {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Device Name',
            'Active',
            'Size Or Screens',
            'Quantity',
            'Hours Tourly'
        ];
        if ( this.state.test.solidsControlEquips ) {
            this.state.test.solidsControlEquips.map((equipmentPiece: ISolidsControl, index: number) => {
                const newObject = [
                    {
                        content: this.inputDeviceName(index),
                        sortItem: equipmentPiece.deviceName,
                        type: 'render',
                    },
                    {
                        content: this.inputInUse(index),
                        sortItem: equipmentPiece.inUse,
                        type: 'render',
                    },
                    {
                        content: this.renderInlineInput(index, 'sizeScreens'),
                        sortItem: equipmentPiece.sizeScreens,
                        type: 'render',
                    },
                    {
                        content: this.renderInlineInputInteger(index, 'quantity'),
                        sortItem: equipmentPiece.quantity,
                        type: 'render',
                    },
                    {
                        content: this.renderInlineInputInteger(index, 'hoursTourly', 24),
                        sortItem: equipmentPiece.hoursTourly,
                        type: 'render'
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const dataSet = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({dataSet});
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private getDeviceNames() {
        this.TestsStore.getDeviceNames(this.state.well.id)
        .then(
            (data: any) => {
                this.setState({
                    deviceNames: data
                });
            }
        );
    }

    private handleDelete(index: number) {
        const test = this.state.test;
        const items = test.solidsControlEquips;
        items.splice(index, 1);
        test.solidsControlEquips = items;
        this.setState({
            isDirty: true,
            test,
        }, () => {
            this.formatDataTable();
        });
    }

    private handleEdit = (index: number) => {
        const solidsControlItem = DeepCopy(this.state.test.solidsControlEquips[index]);
        this.setState({
            editing: true,
            rowIndex: index,
            solidsControlItem,
        });
        this.toggleModal();
    }

    private handleSave = (addAnother: boolean) => () => {
        const { test, rowIndex, solidsControlItem } = this.state;
        if ( this.state.editing ) {
            test.solidsControlEquips[rowIndex] = solidsControlItem;
        } else {
            test.solidsControlEquips.push(solidsControlItem);
        }
        this.setState({
            editing: false,
            isDirty: true,
            solidsControlItem: new ISolidsControl(),
            test,
        });
        this.formatDataTable();
        if (!addAnother) {
            this.toggleModal();
        }
    }

    private handleReorder(startIndex: any, endIndex: any) {
        const test = this.state.test;
        const result = test.solidsControlEquips;
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        this.setState({
            isDirty: true,
            test
        }, () => {
            this.formatDataTable();
        });
    }

    private handleCancel() {
        this.setState({
            editing: false,
            editingIndex: -1,
            solidsControlItem: new ISolidsControl(),
        });
        this.toggleModal();
    }

    private toggleModal() {
        if ( this.state.modal ) {
            this.setState({
                editing: false,
                modal: !this.state.modal,
                solidsControlItem: new ISolidsControl()
            });
        } else {
            this.setState({
                modal: !this.state.modal
            });
        }
    }

    private handleInputChange(event: any) {
        const solidsControlItem = this.state.solidsControlItem;
        solidsControlItem[event.target.name] = event.target.value;
        this.setState({
            solidsControlItem,
        });
    }

    private handleRadioSelect(event: any) {
        const item = this.state.solidsControlItem;
        const inUse = event.target.value;
        item[event.target.name] = ( inUse === 'true' );
        this.setState({
            solidsControlItem: item,
        });
    }

    private addOrdinals(ordinalList: any[]) {
        ordinalList.forEach((value: any, index: any) => {
            value.ordinal = index;
        });
    }

    private updateTestModel = () => {
        this.addOrdinals(this.state.test.solidsControlEquips);
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;

        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/fluiddata/mudproperties');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/fluiddata/tourlytreatment');
        }
    }

    private handleInlineInputChange = (index:number) => (event:any) => {
        const test = this.state.test;
        test.solidsControlEquips[index][event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            test,
        });
    }

    private handleInlineRadioSelect = (index:number) => (event:any) => {
        const test = this.state.test;
        test.solidsControlEquips[index].inUse = !test.solidsControlEquips[index].inUse;
        this.setState({isDirty: true, test});
    }

    private inputDeviceName = (index: number) => () => {
        console.log(this.state.deviceNames);
        const solidsName = this.state.test.solidsControlEquips[index].deviceName as never;

        if(!this.state.deviceNames.includes(solidsName))
        {
            this.state.deviceNames.push(solidsName);
        }
                
            return (
                <FormGroup>
                    <EInput
                        type="select"
                        name="deviceName"
                        id="deviceName"
                        value={this.state.test.solidsControlEquips[index].deviceName}
                        onChange={this.handleInlineInputChange(index)}
                        disabled={true}
                    >
                    <option />
                    { this.state.deviceNames && this.state.deviceNames.map((device: any, oIndex: number) =>
                                                        <option key={oIndex} value={device.deviceName}>{this.state.test.solidsControlEquips[index].deviceName}</option>
                                                    ) }
                    </EInput>
                </FormGroup>
            );
        // }
        return '';
                    
    }

    private inputInUse = (index: number) => () => {
        if (this.state.test.solidsControlEquips[index]) {

            const OnJob = this.state.test.solidsControlEquips[index].inUse;
            return (
                <div>
                <FormGroup check={true} inline={true}>
                    <Label check={true}>
                        <Input
                            name={"onJob" + index}
                            id={"onJob" + index}
                            type="radio"
                            value="true"
                            onChange={this.handleInlineRadioSelect(index)}
                            checked={OnJob}
                            /> Yes
                    </Label>
                </FormGroup>
                <FormGroup check={true} inline={true}>
                    <Label check={true}>
                        <Input
                            name={"onJob" + index}
                            id={"onJob" + index}
                            type="radio"
                            value="false"
                            onChange={this.handleInlineRadioSelect(index)}
                            checked={!OnJob}
                            /> No
                    </Label>
                </FormGroup>
            </div>
            );
        }
        return '';
    }

    private renderInlineInput = (index: any, name: string, iWidth?: number) => () => {
        const solidEquip = this.state.test.solidsControlEquips[index];
        if (solidEquip) {

            return (
                <EInput
                style={iWidth ? {width: iWidth + 'px'} : {}}
                type="text"
                name={name}
                id={name + index}
                value={solidEquip[name]}
                onChange={this.handleInlineInputChange(index)}
                onBlur={this.formatDataTable}
                autoComplete="off"
                />
                );
        }
        return '';
    }
    
    private renderInlineInputInteger = (index: any, name: string, max?: number) => () => {
        const solidEquip = this.state.test.solidsControlEquips[index];
        if (solidEquip) {

            return (
                <EInput
                type="text"
                name={name}
                id={name + index}
                value={solidEquip[name]}
                onChange={this.handleInlineInputChange(index)}
                data-validation="integer"
                data-max={max ? max : Number.MAX_SAFE_INTEGER}
                onBlur={this.formatDataTable}
                autoComplete="off"
                />
                );
        }
        return '';
    }
    public render() {
        const disableWellStatus = this.WellsStore.well && this.WellsStore.well.wellStatus !== 'Active';
        return(
            <div className="SolidsControl">
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <DataTable
                    list={this.state.dataSet}
                    onDelete={this.handleDelete}
                    onEdit={this.handleEdit}
                    onNew={{
                        callback: this.toggleModal,
                        text: 'Add Equipment'
                    }}
                    onReorder={this.handleReorder}
                    disableEditing={disableWellStatus}
                />
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} />
                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal} backdrop="static">
                    <ModalHeader toggle={this.toggleModal}>{ this.state.editing ? 'Edit Solids Control Equipment' : 'Add New Solids Control Equipment' }</ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row>
                                <Col md="12">
                                    <FormGroup className="required">
                                        <Label>Device Name</Label>
                                        <EInput
                                            type="select"
                                            name="deviceName"
                                            id="deviceName"
                                            onChange={this.handleInputChange}
                                            value={ this.state.solidsControlItem.deviceName}
                                            required={true}
                                            disabled={this.state.editing}
                                        >
                                            <option />
                                            { this.state.deviceNames && this.state.deviceNames.map((device: any, index: number) =>
                                                <option key={index} value={device.deviceName}>{device.deviceName}</option>
                                            ) }
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Hours Tourly</Label>
                                        <EInput
                                            type="text"
                                            name="hoursTourly"
                                            id="hoursTourly"
                                            data-validation="integer"
                                            data-max={24}
                                            value={ this.state.solidsControlItem.hoursTourly}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Size or Screens</Label>
                                        <EInput
                                            type="text"
                                            name="sizeScreens"
                                            id="sizeScreens"
                                            value={ this.state.solidsControlItem.sizeScreens}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Quantity</Label>
                                        <EInput
                                            type="text"
                                            name="quantity"
                                            id="quantity"
                                            data-validation="integer"
                                            value={ this.state.solidsControlItem.quantity}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <Label>Active</Label><br/>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <EInput
                                                name="inUse"
                                                id="inUse"
                                                type="radio"
                                                value="true"
                                                onChange={this.handleRadioSelect}
                                                checked={ this.state.solidsControlItem.inUse}
                                            /> Yes
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <EInput
                                                name="inUse"
                                                id="inUse"
                                                type="radio"
                                                value="false"
                                                onChange={this.handleRadioSelect}
                                                checked={!this.state.solidsControlItem.inUse}
                                            /> No
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.handleCancel}>Cancel</Button>
                        <EButton color="primary" onClick={this.handleSave(false)}>Update</EButton>
                        {
                            !this.state.editing &&
                            <EButton color="primary" onClick={this.handleSave(true)}>Add Another</EButton>
                        }
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default withRouter(SolidsControl);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/FluidData/SolidsControl/SolidsControl.tsx